import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import EditableDescription from "@Broker/@Modules/clients/applications/documents/components/utils-components/editable-description";
import MaterialInput from "@Shared/components/inputs/material-input";
import SwitchableInput from "@Shared/components/inputs/switchable-input";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import draggable from "vuedraggable";
import { EDIT_DOCUMENT_TYPE, DELETE_DOCUMENT_TYPE, CREATE_DOCUMENT_TYPE, ORDER_DOCUMENTS_TYPES } from "../../../store/documents-actions";
import { mapActions } from "vuex";
import { isEmpty, orderBy, pick, parseInt } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ManageDocumentTypeModal",
  components: {
    GenericModal,
    InlinePrompt,
    EditableDescription,
    MaterialInput,
    SimpleButton,
    SwitchableInput,
    draggable
  },
  props: {
    documentTypesData: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      modalOpened: false,
      creating: false,
      creatingStatus: true,
      nonce: 0,
      newDocumentTitle: "",
      columns: ["classification", "description", "actions"],
      modelItems: [],
      options: {
        filterable: false,
        showChildRowToggler: false,
        headings: {
          actions: ""
        },
        tabbable: false,
        columnsClasses: {
          classification: "w-30"
        },
        skin: "table table-hover",
        perPage: 99999
      }
    };
  },
  computed: {
    isEmptyData() {
      return isEmpty(this.documentTypesData);
    }
  },
  watch: {
    documentTypesData() {
      this.sortByTypeOrder();
    }
  },
  mounted() {
    this.sortByTypeOrder();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DocumentsStore", [EDIT_DOCUMENT_TYPE, DELETE_DOCUMENT_TYPE, CREATE_DOCUMENT_TYPE, ORDER_DOCUMENTS_TYPES])), {}, {
    async handleRemove({
      documentTypeId
    }) {
      this.DELETE_DOCUMENT_TYPE(documentTypeId);
    },
    handleSaveDescription({
      title,
      documentTypeId,
      description
    }) {
      this.EDIT_DOCUMENT_TYPE({
        documentTypeId: documentTypeId,
        title,
        description
      });
    },
    handleSaveTitle({
      title,
      documentTypeId,
      description
    }) {
      this.EDIT_DOCUMENT_TYPE({
        documentTypeId: documentTypeId,
        title,
        description
      });
    },
    show() {
      this.$refs.manageDocumentTypesModal.show();
    },
    hide() {
      this.$refs.manageDocumentTypesModal.hide();
    },
    async handleCreateDocumentType() {
      if (!this.newDocumentTitle) return;
      this.creating = true;
      try {
        await this.CREATE_DOCUMENT_TYPE(this.newDocumentTitle);
        this.newDocumentTitle = "";
        this.creatingStatus = true;
      } catch (error) {
        this.creatingStatus = false;
      }
      this.creating = false;
    },
    handleHide() {
      this.newDocumentTitle = "";
    },
    sortByTypeOrder() {
      this.modelItems = orderBy(this.documentTypesData, ({
        typeOrder
      }) => parseInt(typeOrder), ["asc"]);
    },
    handleOrder() {
      var _context;
      const documentTypeOrder = _mapInstanceProperty(_context = this.modelItems).call(_context, item => {
        return pick(item, ["documentTypeId", "typeOrder"]);
      });
      this.ORDER_DOCUMENTS_TYPES({
        documentTypeOrder
      });
      this.nonce++;
    }
  })
});